
export default class ServicoService {
  constructor(resource) {
    this._resource = resource;
  }

  getServicos() {
    return this._resource.get("atendimento/servico").then(
      res => res.json(),
      err => {
        console.log(err);
        throw new Error(err.body);
      }
    );
  }

  getServicosByPublico(publicoId, usuarioId) {
    return this._resource
      .get(`atendimento/servico/publico/${publicoId}/${usuarioId}`)
      .then(
        res => res.json(),
        err => {
          console.log(err);
          throw new Error(err.body);
        }
      );
  }

  getServicosByPublicoESite(publicoId, usuarioId, siteId) {
    return this._resource
      .get(`atendimento/servico/publico/${publicoId}/${usuarioId}/${siteId}`)
      .then(
        res => res.json(),
        err => {
          console.log(err);
          throw new Error(err.body);
        }
      );
  }

  getServico(id) {
    return this._resource.get(`atendimento/servico/${id}`).then(
      res => res.json(),
      err => {
        console.log(err);
        throw new Error(err.body);
      }
    );
  }

  getTiposDocumentos(servicoId) {
    return this._resource
      .get(`atendimento/servico/documento/${servicoId}`)
      .then(
        res => res.json(),
        err => {
          console.log(err);
          throw new Error(err.body);
        }
      );
  }

  getDocumentosPendentes(ra) {
    return this._resource
      .post("atendimento/servico/documentos-pendentes", { ra })
      .then(
        res => res.json(),
        err => {
          console.log(err);
          throw new Error(err.body);
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/domain/atendimento/ServicoService.js